var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section", staticStyle: { padding: "10px 0 0 20px" } },
    [
      _c("span", { staticStyle: { color: "red", "line-height": "30px" } }, [
        _vm._v("注意:下列组件为消息提醒，项目中将统一使用该提醒风格 (规约)")
      ]),
      _c(
        "div",
        { staticStyle: { width: "500px" } },
        [
          _c("div", { staticStyle: { "line-height": "30px" } }, [
            _vm._v("Alert 警告 用于页面中展示重要的提示信息。")
          ]),
          _c("el-alert", {
            attrs: { title: "成功提示的文案", type: "success", "show-icon": "" }
          }),
          _c("el-alert", {
            attrs: { title: "消息提示的文案", type: "info", "show-icon": "" }
          }),
          _c("el-alert", {
            attrs: { title: "警告提示的文案", type: "warning", "show-icon": "" }
          }),
          _c("el-alert", {
            attrs: { title: "错误提示的文案", type: "error", "show-icon": "" }
          })
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        [
          _c(
            "el-button",
            { attrs: { plain: true }, on: { click: _vm.open2 } },
            [_vm._v("成功")]
          ),
          _c(
            "el-button",
            { attrs: { plain: true }, on: { click: _vm.open3 } },
            [_vm._v("警告")]
          ),
          _c(
            "el-button",
            { attrs: { plain: true }, on: { click: _vm.open1 } },
            [_vm._v("消息")]
          ),
          _c(
            "el-button",
            { attrs: { plain: true }, on: { click: _vm.open4 } },
            [_vm._v("错误")]
          ),
          _c("el-button", { on: { click: _vm.open } }, [
            _vm._v("Confirm 确认")
          ]),
          _c("el-button", { on: { click: _vm.open5 } }, [_vm._v("Alter 提醒")])
        ],
        1
      ),
      _vm._m(1),
      _c(
        "div",
        [
          _c("el-button", { attrs: { plain: "" }, on: { click: _vm.open11 } }, [
            _vm._v("成功")
          ]),
          _c("el-button", { attrs: { plain: "" }, on: { click: _vm.open21 } }, [
            _vm._v("警告")
          ]),
          _c("el-button", { attrs: { plain: "" }, on: { click: _vm.open31 } }, [
            _vm._v("消息")
          ]),
          _c("el-button", { attrs: { plain: "" }, on: { click: _vm.open41 } }, [
            _vm._v("错误")
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "margin-top": "10px", "line-height": "30px" } },
      [
        _vm._v(" 消息提示 "),
        _c("span", { staticStyle: { color: "red" } }, [
          _vm._v(
            "使用建议：一般用于用户操作过程中的消息提醒(如:提醒用户必填项、需要选择表格行、提交成功、提交失败等);在屏幕中上部显示，更能引起用户的注意"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "margin-top": "10px", "line-height": "30px" } },
      [
        _vm._v(" 通知 "),
        _c("span", { staticStyle: { color: "red" } }, [
          _vm._v(
            "使用建议：一般用于显示一些全局的通知信息(如：系统出错提示、请求超时、待办事务、也可做常用功能的快捷入口等);可在屏幕四个角显示，对用户视觉刺激较弱"
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }